import type { RezaPermissions } from '@gov-nx/api';

export const REZA_OVERVIEW_FORM_PERMISSIONS: RezaPermissions = {
	implicitAllowed: true,
	explicitAllowed: false,
	implicitFilter: [],
	explicitFilter: [],
};

export const REZA_USAGE_FORM_PERMISSIONS: RezaPermissions = {
	implicitAllowed: true,
	explicitAllowed: false,
	implicitFilter: [],
	explicitFilter: [],
};
